import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./lib/auth.tsx";
import { AppLayout } from "./components/layout/AppLayout.tsx";
import Login from "./pages/Login.tsx";
import Dashboard from "./pages/Dashboard.tsx";
import Brands from "./pages/Brands.tsx";
import BrandDetail from "./pages/BrandDetail.tsx";
import Settings from "./pages/Settings.tsx";
import Advisor from "./pages/Advisor.tsx";
import Interest from "./pages/Interest.tsx";
import AdsDoctor from "./pages/AdsDoctor.tsx";
import SecondOpinion from "./pages/SecondOpinion.tsx";
import SalesPageEngine from "./pages/SalesPageEngine.tsx";
import AudienceInsight from "./pages/AudienceInsight.tsx";
import Strategy from "./pages/Strategy.tsx";
import Content from "./pages/Content.tsx";
import Creative from "./pages/Creative.tsx";
import Video from "./pages/Video.tsx";
import Scaling from "./pages/Scaling.tsx";
import ModuleStub from "./pages/ModuleStub.tsx";
import { MODULES } from "@shared/modules.ts";

export default function App() {
  const { loading, user } = useAuth();

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        <div className="spinner spinner--dark" />
      </div>
    );
  }

  if (!user) return <Login />;

  // Modules that have a dedicated page; the rest render an honest "building" stub.
  const built = new Set(["dashboard", "brands", "settings", "advisor", "interest", "ads-doctor", "second-opinion", "sales-page", "audience", "strategy", "content", "creative", "video", "scaling"]);

  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/brands" element={<Brands />} />
        <Route path="/brands/:id" element={<BrandDetail />} />
        <Route path="/advisor" element={<Advisor />} />
        <Route path="/interest" element={<Interest />} />
        <Route path="/ads-doctor" element={<AdsDoctor />} />
        <Route path="/second-opinion" element={<SecondOpinion />} />
        <Route path="/sales-page" element={<SalesPageEngine />} />
        <Route path="/audience" element={<AudienceInsight />} />
        <Route path="/strategy" element={<Strategy />} />
        <Route path="/content" element={<Content />} />
        <Route path="/creative" element={<Creative />} />
        <Route path="/video" element={<Video />} />
        <Route path="/scaling" element={<Scaling />} />
        <Route path="/settings" element={<Settings />} />
        {MODULES.filter((m) => !built.has(m.id)).map((m) => (
          <Route key={m.id} path={m.path} element={<ModuleStub module={m} />} />
        ))}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppLayout>
  );
}
